(function () {
    "use strict";

    var controllerId = "avvisoAggiornamenti";
    angular.module('app').controller(controllerId, ["$scope", "$rootScope", "datacontext", "$uibModalInstance", '$translate', avvisoAggiornamentiFn]);

    function avvisoAggiornamentiFn($scope, $rootScope, datacontext, $uibModalInstance, $translate) {
        $scope.aggiornamento = {};
        getAggiornamento();

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };

        $scope.closeAlways = function () {
            datacontext.updateSettings(-1, -1, 0).then(function (data) {
                $rootScope.mdUpdate = false;
                $uibModalInstance.dismiss('cancel');
            });            
        }

        function getAggiornamento() {
            if ($rootScope.isAuthorized('STUDENTE')) {
                return datacontext.aggiornamento_getByStudente().then(function (data) {
                    $scope.aggiornamento = data;
                });
            } else {
                return datacontext.aggiornamento_getByDocente().then(function (data) {
                    $scope.aggiornamento = data;
                });
            }
            
        }
    }
})();